import { DatePipe } from '@angular/common';
import { Directive } from '@angular/core';
import { ColumnDefinition } from '../advanced-gridview/models/column-definition';
import { ColumnType } from '../advanced-gridview/models/column-type';
import { BaseDirective } from './base.directive';

@Directive({
    selector: '[appFilter]',
    standalone: true,
})
export class FilterDirective extends BaseDirective {
    constructor(public override datePipe: DatePipe) {
        super(datePipe);
    }

    /**
     * Retourne une valeur indiquant si le type de saisie du filtre de la colonne est standard (texte ou nombre).
     * @param attribute : Attribut.
     * @returns : true si le type de saisie du filtre de la colonne est standard (texte ou nombre); false autrement.
     */
    public isStandardInput(attribute: ColumnDefinition): boolean {
        return attribute.type === ColumnType.Text || attribute.type === ColumnType.Numeric;
    }

    /**
     * Retourne une valeur indiquant si le type de saisie du filtre de la colonne est de type booléen.
     * @param attribute : Attribut.
     * @returns : true si le type de saisie du filtre de la colonne est de type booléen; false autrement.
     */
    public isBooleanInput(attribute: ColumnDefinition): boolean {
        return attribute.type === ColumnType.Boolean;
    }

    /** Retourne une valeur indiquant si le type est liste */
    public isListInput(attribute: ColumnDefinition): boolean {
        return attribute.type === ColumnType.List;
    }

    /**
     * Retourne une valeur indiquant si le type de saisie du filtre de la colonne est de type date.
     * @param attribute : Attribut.
     * @returns : true si le type de saisie du filtre de la colonne est de type date; false autrement.
     */
    public isDateInput(attribute: ColumnDefinition): boolean {
        return attribute.type === ColumnType.Date;
    }

    /**
     * Retourne une valeur indiquant si le type de saisie du filtre de la colonne est de type date & heure.
     * @param attribute : Attribut.
     * @returns : true si le type de saisie du filtre de la colonne est de type date & heure; false autrement.
     */
    public isDateAndTimeInput(attribute: ColumnDefinition): boolean {
        return attribute.type === ColumnType.DateAndTime;
    }
}
